import React__default from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/index.js';
import StyledBadge from './Badge.styles.js';
import { BADGE_VARIANTS, BADGE_ICONS } from './Badge.constants.js';

var Badge = function Badge(_ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? BADGE_VARIANTS.INFO : _ref$variant,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$hasBackground = _ref.hasBackground,
    hasBackground = _ref$hasBackground === void 0 ? true : _ref$hasBackground,
    _ref$hasIcon = _ref.hasIcon,
    hasIcon = _ref$hasIcon === void 0 ? true : _ref$hasIcon;
  return React__default.createElement(StyledBadge, {
    $variant: variant,
    $hasBackground: hasBackground,
    $hasIcon: hasIcon,
    "data-testid": testId
  }, hasIcon && React__default.createElement(Icon, {
    variant: BADGE_ICONS[variant],
    size: "tiny"
  }), children);
};
Badge.propTypes = {
  children: PropTypes.node.isRequired,
  hasBackground: PropTypes.bool,
  hasIcon: PropTypes.bool,
  testId: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(BADGE_VARIANTS))
};
var Badge$1 = Badge;

export { Badge$1 as default };
//# sourceMappingURL=Badge.js.map
